/* eslint-disable */
// AUTO-GENERATED by scripts/gen-lang-index.mjs (via compile:i18n) — do not edit.
import f0 from './base.json';
import f1 from './de.ameland.json';
import f2 from './de.campercontact.json';
import f3 from './de.json';
import f4 from './de.oberon.json';
import f5 from './de.qualitylodgings.json';
import f6 from './de.schier.json';
import f7 from './de.terschelling.json';
import f8 from './de.texel.json';
import f9 from './de.wadden.json';
import f10 from './de.waterland.json';
import f11 from './de.zandvoort.json';
import f12 from './en.ameland.json';
import f13 from './en.campercontact.json';
import f14 from './en.json';
import f15 from './en.oberon.json';
import f16 from './en.qualitylodgings.json';
import f17 from './en.schier.json';
import f18 from './en.terschelling.json';
import f19 from './en.texel.json';
import f20 from './en.wadden.json';
import f21 from './en.waterland.json';
import f22 from './en.zandvoort.json';
import f23 from './nl.ameland.json';
import f24 from './nl.campercontact.json';
import f25 from './nl.json';
import f26 from './nl.oberon.json';
import f27 from './nl.qualitylodgings.json';
import f28 from './nl.schier.json';
import f29 from './nl.terschelling.json';
import f30 from './nl.texel.json';
import f31 from './nl.wadden.json';
import f32 from './nl.waterland.json';
import f33 from './nl.zandvoort.json';

const map = {
    './base.json': f0,
    './de.ameland.json': f1,
    './de.campercontact.json': f2,
    './de.json': f3,
    './de.oberon.json': f4,
    './de.qualitylodgings.json': f5,
    './de.schier.json': f6,
    './de.terschelling.json': f7,
    './de.texel.json': f8,
    './de.wadden.json': f9,
    './de.waterland.json': f10,
    './de.zandvoort.json': f11,
    './en.ameland.json': f12,
    './en.campercontact.json': f13,
    './en.json': f14,
    './en.oberon.json': f15,
    './en.qualitylodgings.json': f16,
    './en.schier.json': f17,
    './en.terschelling.json': f18,
    './en.texel.json': f19,
    './en.wadden.json': f20,
    './en.waterland.json': f21,
    './en.zandvoort.json': f22,
    './nl.ameland.json': f23,
    './nl.campercontact.json': f24,
    './nl.json': f25,
    './nl.oberon.json': f26,
    './nl.qualitylodgings.json': f27,
    './nl.schier.json': f28,
    './nl.terschelling.json': f29,
    './nl.texel.json': f30,
    './nl.wadden.json': f31,
    './nl.waterland.json': f32,
    './nl.zandvoort.json': f33,
} as unknown as Record<string, Record<string, string>>;

const requireContext = Object.assign(
    (key: string): Record<string, string> => {
        if (!(key in map)) {
            throw new Error(`Unknown lang catalog ${key} — expected one of: ${Object.keys(map).join(', ')}`);
        }
        return map[key];
    },
    {
        keys: (): string[] => Object.keys(map),
    }
);

export default requireContext;
